import type { SVGProps } from 'react';
import { resolveSprite } from './registry';

export type CharacterSpriteProps = {
  pieceValue: number;
  skinId?: string;
  className?: string;
  svgProps?: SVGProps<SVGSVGElement>;
};

/**
 * Still character art for DOM surfaces (reserve rails, graveyard, store).
 * Frame-by-frame playback lives on the Pixi board in `modules/Game/pixi`.
 */
export default function CharacterSprite({
  pieceValue,
  skinId = 'classic',
  className = '',
  svgProps,
}: CharacterSpriteProps) {
  const def = resolveSprite(pieceValue, skinId);
  if (!def) {
    throw new Error(`No sprite registered for piece value ${pieceValue}`);
  }

  if (def.kind === 'sheet') {
    return (
      <div
        className={[
          'flex h-full w-full items-center justify-center overflow-visible',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <img
          src={def.staticUrl}
          alt=""
          aria-hidden
          draggable={false}
          className="max-h-full max-w-full object-contain"
        />
      </div>
    );
  }

  const { Svg } = def;
  const tintFill =
    typeof svgProps?.style?.fill === 'string' ? svgProps.style.fill : undefined;

  return (
    <div
      className={[
        'flex h-full w-full items-center justify-center overflow-visible',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Svg
        {...svgProps}
        fill={tintFill}
        color={tintFill}
        className="max-h-full max-w-full origin-center"
        style={{
          ...svgProps?.style,
          color: tintFill,
          fill: tintFill,
          width: 'auto',
          height: '100%',
          aspectRatio: '1',
          maxWidth: '100%',
        }}
      />
    </div>
  );
}
